import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Member_Projectlist() {
    const navigate = useNavigate();
    const [listProjectArray, setListProjectArray] = useState([]);
    const [memFirstName, setMemFirstName] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    var memfname = localStorage.getItem('memberFirstname');
    useEffect(() => {

        const userid = localStorage.getItem('member_id');
        var obj = {
            userid: userid
        }
        $.ajax({
            type: 'POST',
            url: 'getMembersProjects.php',
            data: obj,
            cache: false,
            dataType: 'json', // ✅ ADD THIS LINE
            success: function (parsedResult) {
                console.log(parsedResult);

                if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                    setListProjectArray(parsedResult);
                } else {
                    showAlert('You have No active projects.');
                    setListProjectArray([]);
                }
            },
            error: function (xhr, status, error) {
                console.error("AJAX Error:", xhr.responseText);
                showAlert('Failed to load your record.');
            }
        });
        setOthers()
    }, [])

    function setOthers() {
        setMemFirstName(memfname)
    }

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function goForMemberProjectDetails(id, pro_name, deadline) {
        localStorage.setItem('selected_project_id', id);
        localStorage.setItem('selected_project_name', pro_name);
        localStorage.setItem('initialpage', 'members');
        localStorage.setItem('deadline', deadline);
        navigate('/project_details');
    }

    function acceptTheProject(proid, pro_name, memberid, memberemail, membername) {
        var trgurl = "https://siddhartha.utopa.in/acceptproject.php?memid=" + memberid + "&proid=" + proid + "&proname=" + pro_name + "&companyname=" + membername + "&mememai=" + memberemail
        window.location.href = trgurl
    }
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Your Projects</h2>
                    <Link className='pull_right add_new_pro' to="/member_complete_projects">View Completed Projects</Link>
                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <p>{memFirstName} here you can see only those project where you are involved</p>
                    <div className='vl_listing_area'>

                        {listProjectArray.map((item, index) => {
                            // const activestatus = item.project_status === 'active';
                            const acceptpro = item.accept;
                            //  if (!activestatus) return null; // skip inactive items

                            return (
                                <div className='resource_card_one_third' key={index}>
                                    <div className='resource_inner'>
                                        <div className='fullwidth pull_left pt-21'>
                                            <h3>{item.pro_name}</h3>
                                        </div>
                                        <div className='divider'>&nbsp;</div>
                                        <div className='vl_dsh_one_half'>
                                            <p>Role: {item.member_role}</p>
                                        </div>

                                        <div className='vl_dsh_one_half'>
                                            <p>Accept: {item.accept}</p>
                                        </div>

                                        <div className='vl_dsh_one_full'>
                                            <p>Deadline: {item.deadline}</p>
                                        </div>

                                        <div className='list_buttonholder'>
                                            {acceptpro === 'yes' ? (
                                                <button onClick={() => goForMemberProjectDetails(item.proid, item.pro_name, item.deadline)}>
                                                    View
                                                </button>
                                            ) : (
                                                <button onClick={() => acceptTheProject(item.proid, item.pro_name, item.memberid, item.memberemail, item.membername)}>
                                                    Not accepted
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>

        </div>
    )
}
